import * as API from "../../api";
import {SIGNIN_SUCCESS, SIGNIN_FAILURE, SIGNIN_ERROR_CLEAR, LOGOUT} from "../../constants/actionTypes";
import getUserData from "../../api/user";
import {playFeedbackWave} from "../../utils/feedbackWave";

export const userSignIn = (formData, navigate) => async (dispatch) => {
    try {
        const response = await API.SIGN_IN({
            ...formData,
        });

        const user = await getUserData({username: formData.username, token: response.data.token})
        if (response.status === 200) {
            dispatch({
                type: SIGNIN_SUCCESS,
                payload: {data: user, token: response.data.token}
            });

            playFeedbackWave('success');
            navigate("/analysis");
        } else {
            playFeedbackWave('failure');
            dispatch({type: SIGNIN_FAILURE, payload: 'generic'});
        }
    } catch (error) {
        playFeedbackWave('failure');
        dispatch({type: SIGNIN_FAILURE, payload: error.response?.status === 400 ? 'invalid' : 'generic'});
    }
};

export const clearSignInError = () => ({type: SIGNIN_ERROR_CLEAR});

export const logout = () => (dispatch) => {
    dispatch({type: LOGOUT});
};